var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 81"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diamond_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    opacity: 0.6,
    d: "M38.832 80.973a1.438 1.438 0 0 0 2.336 0l32.414-45.377a2.271 2.271 0 0 0-.024-2.66L59.663 14.164a1.479 1.479 0 0 0-1.182-.59H21.525a1.48 1.48 0 0 0-1.183.59l-13.9 18.76a2.273 2.273 0 0 0-.024 2.66l32.414 45.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.792,
    d: "M40.01 79.177 27.407 34.573m-.02-.06 12.625-19.544 12.624 19.544H27.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.792,
    d: "m40.01 79.177 12.647-44.75H72.5l-32.49 44.75Zm-.52 0-12.647-44.75H7l32.49 44.75v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.86 2.198 4.342 5.92a1.07 1.07 0 0 1-.263 1.446c-.395.263-.92.263-1.315-.131l-5.13-5.13c-.658-.658-.658-1.58 0-2.237.657-.658 1.578-.658 2.236 0 0 0 0 .132.13.132ZM1.235 58.843l6.972-2.237c.526-.131 1.052.132 1.184.658.13.526 0 .92-.527 1.184l-6.577 3.289c-.79.394-1.71.13-2.105-.658-.394-.79-.131-1.71.658-2.105.263-.131.395-.131.395-.131Zm76.87 2.894-6.578-3.288c-.526-.264-.657-.79-.394-1.316.263-.395.789-.658 1.183-.526l6.972 2.236c.79.263 1.316 1.184 1.053 1.973-.263.79-1.184 1.316-1.973 1.053-.132-.132-.132-.132-.263-.132ZM71.873 4.493 66.61 9.61a1.07 1.07 0 0 1-1.47-.06 1.012 1.012 0 0 1-.052-1.322l4.372-5.79c.56-.743 1.473-.87 2.215-.31.742.56.87 1.473.31 2.215l-.113.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.792,
    d: "M27.406 34.573 22 14.973h18l-12.594 19.6Zm25.188 0L58 14.973H40l12.594 19.6v0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diamond_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v81H0z"
  })))));
};
export default SvgDiamond;